import "./App.css";
import { Route, Routes } from "react-router-dom";
import Allazkar from "./Components/Allazkar";
// Get Images
import unionTop from "./Images/Desktop-2/Union-top.svg";
import unionBottom from "./Images/Desktop-2/Union-bottom-left.png";
// Simgle Components
import ContentAzkar from "./Components/ContentAzkar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BgApp from "./Components/BgApp";
import NavbarC from "./layout/Navbar";
import { TestNav } from "./layout/TestNavbar";
import AfterPrayer from "./Components/AfterPrayer/AfterPrayer";

function App() {
  // <NavbarC />
  return (
    <>
      <BgApp />
      {window.innerWidth >= 992 ? <NavbarC /> : <TestNav />}
      <ToastContainer
        className={`relative`}
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
      {/* Same as */}
      <ToastContainer />
      <div className="w-100 flex justify-center">
        <img className="mx-auto absolute top-0 z-10" src={unionTop} alt="" />
      </div>
      <Routes>
        <Route
          path="/"
          element={
            <div className="homepage">
              <Allazkar />
            </div>
          }
        />
        <Route path="/afterPrayer" element={<AfterPrayer />} />
        <Route
          path="/morning"
          element={
            <>
              <ContentAzkar />
            </>
          }
        />
        <Route
          path="/evening"
          element={
            <>
              <ContentAzkar />
            </>
          }
        />
        <Route
          path="/gettingUp"
          element={
            <>
              <ContentAzkar />
            </>
          }
        />
      </Routes>
      <img
        className=" absolute bottom-0  left-0 z-0"
        src={unionBottom}
        alt=""
      />
    </>
  );
}

export default App;
